<template>
  <div class="myh-detail-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myh_management/myh_management_home' }">密友会管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myh_management/myh_list' }">密友会列表</el-breadcrumb-item>
      <el-breadcrumb-item>密友会详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">密友会详情</span>
        </el-col>
      </el-row>

      <el-descriptions :column="2" border size="medium" class="detail-descriptions">
        <el-descriptions-item label="主键ID">{{ displayText(detail.id) }}</el-descriptions-item>
        <el-descriptions-item label="赛区编号">{{ displayText(detail.code) }}</el-descriptions-item>
        <el-descriptions-item label="密友会名称">{{ detail.name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="秘书长">{{ detail.secretaryGeneral || '-' }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ detail.email || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ detail.contactPhone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="是否关闭">
          <el-tag v-if="+detail.isClosed === 1" type="danger" size="mini">
            {{ detail.isClosedName || '已关闭' }}
          </el-tag>
          <el-tag v-else type="success" size="mini">
            {{ detail.isClosedName || '正常' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatTime(detail.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatTime(detail.updateTime) }}</el-descriptions-item>
      </el-descriptions>

      <el-card shadow="never" class="inner-card">
        <div slot="header" class="inner-title">简介</div>
        <div class="multiline-text">{{ detail.intro || '-' }}</div>
      </el-card>

      <el-card shadow="never" class="inner-card">
        <div slot="header" class="inner-title">备注</div>
        <div class="multiline-text">{{ displayText(detail.remark) }}</div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import { myhClubDetail } from '@/http/api'

export default {
  name: 'MyhDetail',
  data () {
    return {
      detail: {}
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      const id = this.$route.query.id
      if (!id) {
        this.$message.warning('缺少详情ID')
        return
      }
      myhClubDetail({ id }).then((res) => {
        this.detail = res.data || {}
      })
    },
    displayText (value) {
      if (value === null || value === undefined || value === '') return '-'
      return String(value)
    },
    formatTime (value) {
      if (!value) return '-'
      const num = Number(value)
      if (Number.isNaN(num) || num <= 0) return '-'
      return this.$moment(num).format('YYYY-MM-DD HH:mm:ss')
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.myh-detail-page {
  padding: 0;
}

.inner-card {
  margin-top: 12px;
}

.inner-title {
  font-weight: 600;
}

.multiline-text {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.6;
}

.detail-descriptions {
  margin-bottom: 10px;
}
</style>
